import React, { useState, useEffect } from 'react'
import { Dimensions, StyleSheet, Text, Image, View, TouchableOpacity } from 'react-native'
import { LABEL_STATE, LABElS } from '../constants'
// Platform import removed - using platformUtils instead
import { Feather } from '@expo/vector-icons'
import theme from '../../../../theme'
import styles from './AlertAssesmentStyles'
import { LinearGradient } from 'expo-linear-gradient'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import { translateLabel } from '../CourseHome'
import { colorIcon, colorText } from '../../../../themeConstants'
import { isValidUrl } from '../../../utils/functions.utils'

interface Props {
    onPress: () => void
    label: string
    porcentanje_aprobacion: string
    curso: any
    onPressCertificate: (url: string) => void
    isWeb: boolean
}

const { width, height } = Dimensions.get('window')

export const AlertAssesment = ({ onPress, label, porcentanje_aprobacion, curso, onPressCertificate, isWeb = false }: Props) => {
    // console.log('🚀 ~ AlertAssesment ~ label:', label)
    // console.log('🚀 ~ AlertAssesment ~ porcentanje_aprobacion:', porcentanje_aprobacion)

    const { languageFile } = getLanguage()

    const [texts, setTexts] = useState({
        title: '',
        description: '',
        btn_text: '',
        score: '',
    })

    const set_labels = (porcentanje_aprobacion: string) => {
        let title: string
        let description: string
        let btn_text: string
        const score =
            Number(porcentanje_aprobacion) === parseInt(porcentanje_aprobacion)
                ? Number(porcentanje_aprobacion).toFixed(0)
                : Number(porcentanje_aprobacion).toFixed(0)
        if (label === LABEL_STATE.label_course_pending) {
            title = languageFile.pending_approval
            description = '' //`Calificación: ${score}%`
            btn_text = languageFile.return
        } else {
            if (label === LABEL_STATE.label_course_complete) {
                title = languageFile.congratulations
                description = languageFile.you_approved + `${score}%`
                // Si se descomenta esto, corregir abajo
                // btn_text = 'Descargar certificado'
                btn_text = languageFile.return_to_course
            } else if (label === LABEL_STATE.label_evaluation && porcentanje_aprobacion) {
                title = languageFile.you_disapproved
                description = languageFile.score + ` ${score}%`
                btn_text = 'REINTENTAR EVALUACIÓN'
            } else {
                title = languageFile.it_is_available
                description = languageFile.total_course_evaluation
                btn_text = languageFile.evaluate_me
            }
        }

        setTexts({
            title,
            description,
            btn_text,
            score,
        })
    }

    const imagePath =
        label === LABEL_STATE.label_course_complete
            ? require('../../../../assets/evaluations/evaluationApprovedAsset.png')
            : label === LABEL_STATE.label_course_pending
            ? require('../../../../assets/evaluations/evaluationCourseAsset.png')
            : label === LABEL_STATE.label_evaluation && porcentanje_aprobacion
            ? require('../../../../assets/evaluations/evaluationDisapprovedAsset.png')
            : require('../../../../assets/evaluations/evaluationPendingAsset.png')

    useEffect(() => {
        set_labels(porcentanje_aprobacion)
    }, [label, porcentanje_aprobacion])

    if (isWeb) {
        return (
            <View style={[{ flexDirection: 'column' }, isWeb && { position: 'relative', marginEnd: 25 }]}>
                <View
                    style={{
                        flex: 1,
                        flexDirection: 'row',
                        zIndex: 1,
                    }}
                >
                    <View
                        style={{
                            flex: 1,
                            zIndex: 1,
                        }}
                    >
                        <View>
                            <Text
                                style={[
                                    styles.textDescription,
                                    {
                                        color: theme.colors.colorApproved,
                                    },
                                ]}
                            >
                                {texts.description}
                            </Text>
                            {label === LABEL_STATE.label_course_complete && curso.certificate && curso.certificate != '' && (
                                <TouchableOpacity onPress={() => onPressCertificate(curso.certificate)} style={{ marginTop: 4 }}>
                                    <Text
                                        style={{
                                            fontSize: 14,
                                            color: theme.colors.colorApproved,
                                            fontWeight: 'bold',
                                            textDecorationLine: 'underline',
                                            textDecorationColor: theme.colors.colorApproved,
                                        }}
                                    >
                                        {languageFile.view_certificate}
                                    </Text>
                                </TouchableOpacity>
                            )}
                        </View>
                    </View>
                </View>
            </View>
        )
    }
    return curso.evaluations && curso.evaluations.length > 0 ? (
        <View style={[styles.invisibleContainer, isWeb && { position: 'relative' }]}>
            <TouchableOpacity onPress={onPress}>
                <LinearGradient
                    style={styles.container}
                    colors={[
                        texts.btn_text === languageFile.evaluate_me
                            ? theme.colors.linearGradientEnd
                            : texts.btn_text === 'REINTENTAR EVALUACIÓN'
                            ? theme.colors.linearGradientRedEnd
                            : theme.colors.linearGradientGreenStart,
                        texts.btn_text === languageFile.evaluate_me
                            ? theme.colors.linearGradientStart
                            : texts.btn_text === 'REINTENTAR EVALUACIÓN'
                            ? theme.colors.linearGradientRedStart
                            : theme.colors.linearGradientGreenEnd,
                    ]}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 0 }}
                >
                    <View style={[styles.feedbackAssetContainer]}>
                        <Image style={[styles.feedbackAsset]} source={imagePath} />
                    </View>

                    <View style={styles.levelKnowledgeBlock}>
                        <View>
                            <Text
                                style={[
                                    styles.titleNextModule,
                                    {
                                        color:
                                            texts.btn_text === languageFile.evaluate_me
                                                ? colorText
                                                : texts.btn_text === 'REINTENTAR EVALUACIÓN'
                                                ? 'white'
                                                : 'white',
                                    },
                                ]}
                            >
                                {texts.btn_text}
                            </Text>

                            {/* <Text style={styles.textTitle}>{texts.title} </Text> */}

                            <Text
                                style={[
                                    styles.textDescription,
                                    {
                                        color:
                                            texts.btn_text === languageFile.evaluate_me
                                                ? colorText
                                                : texts.btn_text === languageFile.retry_mayus
                                                ? 'white'
                                                : 'white',
                                    },
                                ]}
                            >
                                {texts.description}
                            </Text>
                            {label === LABEL_STATE.label_course_complete && curso.certificate && isValidUrl(curso.certificate) && (
                                <TouchableOpacity style={styles.secondaryButton} onPress={() => onPressCertificate(curso.certificate)}>
                                    <Text style={styles.secondaryButtonText}>{languageFile.view_certificate}</Text>
                                </TouchableOpacity>
                            )}
                        </View>
                    </View>
                    <Feather style={styles.iconButton} name='chevron-right' size={18} color={colorIcon} />
                </LinearGradient>
            </TouchableOpacity>
        </View>
    ) : (
        <View style={[styles.invisibleContainer, isWeb && { position: 'relative' }]}>
            <TouchableOpacity onPress={onPress}>
                <LinearGradient
                    style={styles.container}
                    colors={[theme.colors.linearGradientGreenStart, theme.colors.linearGradientGreenEnd]}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 0 }}
                >
                    <View style={styles.feedbackAssetContainer}>
                        <Image style={styles.feedbackAsset} source={imagePath} />
                    </View>

                    <View style={styles.levelKnowledgeBlock}>
                        <View>
                            {/*<Text style={styles.titleNextModule}>{languageFile.back}</Text>*/}

                            <Text style={styles.textTitle}>{texts.title} </Text>

                            <Text style={styles.textDescription}>{languageFile.completed_the_course}</Text>
                        </View>
                    </View>
                    <Feather style={styles.iconButton} name='chevron-right' size={18} color={'white'} />
                </LinearGradient>
            </TouchableOpacity>
        </View>
    )
}

export const AlertCompleteNoEvaluation = ({ onPress, label }: Props) => {
    const { languageFile } = getLanguage()

    const [texts, setTexts] = useState({
        title: languageFile.congratulations,
        description: languageFile.you_completed,
        btn_text: languageFile.return_to_course,
    })

    const imagePath = require('../../../../assets/evaluations/evaluationFinishedAsset.png')

    {
        /* label === LABEL_STATE.label_course_complete
            ? require('../../../../assets/evaluations/evaluationApprovedAsset.png')
            : label === LABEL_STATE.label_evaluation
            ? require('../../../../assets/evaluations/evaluationDisapprovedAsset.png')
            : require('../../../../assets/evaluations/evaluationPendingAsset.png')
        */
    }

    return (
        <View style={styles.invisibleContainer}>
            <View style={[styles.feedbackAssetContainer]}>
                <Image style={[styles.feedbackAsset]} source={imagePath} />
            </View>
            <View style={styles.container}>
                <View>
                    <Text style={styles.textTitle}>{texts.title}</Text>
                    <Text style={[styles.textDescription, { color: theme.colors.colorShare }]}>{texts.description}</Text>
                    <TouchableOpacity onPress={onPress} style={styles.finishButton}>
                        <Text style={styles.mainButtonText}>{languageFile.return_to_course}</Text>
                    </TouchableOpacity>
                </View>
            </View>
        </View>
    )
}
